import { Next } from '@securitize/ui-components';

export const getInvestorTokenDetailsNext = new Next('/investor-tokens/{tokenId}', 'GET_INVESTOR_TOKEN_DETAILS');
